<template>
  <v-row class="ma-0">
    <v-col md="12" cols="12">
      <CartItem
        v-for="product in shoppingCart.products"
        :key="product.id"
        :name="product.name"
        :image="product.image"
        :quantity="product.quantity"
        :price="product.price"
        :sku="product.sku"
        @updateProductQuantity="updateProductQuantity"
        @deleteProduct="handleDeleteProduct"
      />
    </v-col>
    <v-col md="12" cols="12">
      <CartOrderSummary
        :buttonText="
          isCartRoute ? $t('cart.overview.button') : $t('cart.popover.button')
        "
        @checkout="routeCart"
        showButton
      />
    </v-col>
    <v-snackbar v-model="showSnackbar" location="bottom">
      {{ $t('cart_error_stock') }}
    </v-snackbar>
  </v-row>
</template>

<script setup>
import { useShoppingCartApi } from "@/composables/useShoppingCartApi";
import CartItem from "@/components/Cart/CartItem.vue";
import { useShoppingCartStore } from "@/store/shoppingCart";
import { useRoute } from "vue-router";
const { $methods } = useNuxtApp();
const { updateCart, deleteCartItem } = useShoppingCartApi();

const shoppingCart = useShoppingCartStore();
const route = useRoute();
const showSnackbar = ref(false);

const isCartRoute = computed(() => route.path === "/cart");

async function routeCart() {
  if (isCartRoute.value) {
    await navigateTo($methods.urlPageType("WB"));
  } else {
    await navigateTo($methods.urlPageType("WB"));
  }
}

const props = defineProps({
  products: Array,
});

async function updateProductQuantity({ sku, name, updatedQuantity, revertQuantity }) {
  const response = await updateCart(sku, name, updatedQuantity);
  if (response?.data?.exceedsStock) {
    revertQuantity();
    showSnackbar.value = true;
  }
}

function handleDeleteProduct({ sku }) {
  deleteCartItem(sku);
}
</script>